import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Text, Youtube } from "@cinch-labs/design-system";
import { BLOK_YOUTUBE, getStoryblokImageServiceUrl, isYoutubeBlok } from "@cinch-nx/data-storyblok";
import { MARK_BOLD, NODE_IMAGE, NODE_PARAGRAPH, render } from "storyblok-rich-text-react-renderer";
import styles from "./rich-text-renderer.module.css";
var resolveYoutubeVideo = function(props) {
    return isYoutubeBlok(props) ? /*#__PURE__*/ _jsx(Youtube, _object_spread_props(_object_spread({}, props), {
        className: styles.video,
        customThumbnail: props.thumbnail.filename
    })) : null;
};
var renderWithResolver = function(body, makeId) {
    var _obj;
    return render(body, _object_spread({
        nodeResolvers: (_obj = {}, _define_property(_obj, NODE_IMAGE, function(_, props) {
            var _src;
            var optimizedImageUrl = getStoryblokImageServiceUrl((_src = props.src) !== null && _src !== void 0 ? _src : "", {
                filters: [
                    {
                        quality: 80
                    }
                ]
            });
            return /*#__PURE__*/ _jsx("img", _object_spread_props(_object_spread({}, props), {
                src: optimizedImageUrl,
                style: {
                    height: "auto"
                },
                alt: props.alt
            }));
        }), _define_property(_obj, NODE_PARAGRAPH, function(children) {
            return children ? /*#__PURE__*/ _jsx(Text, {
                className: styles.rtParagraph,
                children: children
            }) : null;
        }), _obj),
        blokResolvers: _define_property({}, BLOK_YOUTUBE, function(props) {
            return resolveYoutubeVideo(props);
        })
    }, makeId && {
        markResolvers: _define_property({}, MARK_BOLD, function(children) {
            /*#__PURE__*/ return _jsx("strong", {
                id: children === null || children === void 0 ? void 0 : children.toLocaleString().replace(/\s/g, ""),
                children: children
            });
        })
    }));
};
export default renderWithResolver;
